import Link from 'next/link';

import { PublicPageLayout } from '../../PublicPageLayout';

const ErrorPage = () => {
  return (
    <PublicPageLayout title="Oops, this page can't be found">
      <p className="text-center">
        It looks like the page you searched for has been moved, jump back to the{' '}
        <Link href="/">
          <span className="text-underline">home page</span>
        </Link>{' '}
        or have a read of our blog{' '}
        <Link href="/blog">
          <span className="text-underline">here</span>
        </Link>
        .
      </p>
    </PublicPageLayout>
  );
};

export { ErrorPage };
